import { RequestedPartDetail } from "@/lib/queries/types";
import SwitchOperation from "./SwitchOperation";
import RowLayout from "./lib/RowLayout";
import { components } from "@/lib/ApiSchema";
import Button from "@/lib/Button";
import FooterRow from "./FooterRow";
import useToPage from "@/lib/useToPage";
import SubPartIcon from "~icons/local/sub-part";
import { quantityColumnWidth } from "./constants";
import useOperationListContext from "./lib/useOperationListContext";
import OperationContext from "./lib/OperationContext";
import OperationListContext from "./lib/OperationListContext";
import QuantityInParent from "../QuantityInParent";
import useUpdateOperation from "@/lib/queries/useUpdateOperation";

export default function SubpartList({
  subparts,
}: {
  subparts: components["schemas"]["RequestedPartWithOperationsSchema"][];
}) {
  const { toPart } = useToPage();
  const updateOperation = useUpdateOperation();

  return (
    <div className="border-2 border-slate-400 w-full flex flex-col rounded-b-xl rounded-tr-xl mb-2 divide-y-2 divide-slate-400">
      {subparts.map((subPart) => (
        <div key={subPart.id} className="relative py-2">
          <OperationListContext.Provider
            value={{ quantities: subPart.requested_quantities }}
            key={subPart.id}
          >
            <RowLayout
              left={<Left part={subPart} />}
              right={<Right />}
              className="sticky top-8"
            />
            {subPart.operations.slice(0, 2).map((data) => (
              <OperationContext.Provider
                value={{
                  operationData: data,
                  allowActions: false,
                  updateOperation,
                }}
                key={data.id}
              >
                <SwitchOperation type={data.type} />
              </OperationContext.Provider>
            ))}
            <FooterRow
              operations={subPart.operations}
              left={
                <Button
                  className="ml-4"
                  secondary
                  onClick={() => toPart(subPart.id)}
                >
                  Open Full Estimate
                </Button>
              }
            />
          </OperationListContext.Provider>
          {subPart.will_bid !== null && (
            <div
              className={`absolute top-0 right-0 left-0 h-full ${subPart.will_bid ? "bg-green-500/10" : "bg-red-500/10"} z-10 cursor-not-allowed`}
            />
          )}
        </div>
      ))}
    </div>
  );
}

function Left({ part }: { part: RequestedPartDetail }) {
  return (
    <div className="w-full px-2 flex justify-between items-center">
      <div className="flex gap-1">
        {part.qty_for_parent && (
          <QuantityInParent
            part={part}
            icon={<SubPartIcon className="size-3" />}
          />
        )}
        <div>
          {part.part_number} <span className="text-slate-500">Rev</span>{" "}
          {part.revision_number}
        </div>
      </div>
      <div className="text-sm">Quantities ({part.qty_for_parent}×parent)</div>
    </div>
  );
}

function Right() {
  const { quantities } = useOperationListContext();
  return (
    <div className="flex divide-x divide-slate-100 text-sm">
      {quantities.map((q, i) => (
        <div
          key={i}
          className="flex justify-center items-center"
          style={{
            maxWidth: quantityColumnWidth,
            minWidth: quantityColumnWidth,
          }}
        >
          {q}
        </div>
      ))}
    </div>
  );
}
